import I18n from 'I18n';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue, getAssociatedContentTranslations } from 'content-management-data-lib';
export const getContentId = crmObject => {
  return parseInt(getPropertyValue(crmObject, 'hs_id'), 10);
};
export const getContentIds = crmObjects => {
  return crmObjects.map(getContentId);
};
export const getContentObjectsWithMultiLangVariations = crmObjects => {
  return crmObjects.reduce((acc, crmObject) => {
    acc.push(crmObject);
    const translations = getAssociatedContentTranslations(crmObject);
    acc.push(...translations);
    return acc;
  }, []);
};
export const getContentIdsWithMultiLangVariations = crmObjects => {
  return crmObjects.reduce((acc, crmObject) => {
    acc.push(getContentId(crmObject));
    const translations = getAssociatedContentTranslations(crmObject);
    acc.push(...translations.map(getContentId));
    return acc;
  }, []);
};
export const getContentName = crmObject => {
  return getPropertyValue(crmObject, 'hs_name');
};
export const getContentNameWithLanguage = crmObject => {
  const language = getPropertyValue(crmObject, 'hs_language');
  const name = getContentName(crmObject);
  if (language) {
    return `${name} (${I18n.text(`SharedI18nStrings.languageNames.${language}`)})`;
  }
  return name;
};
export const getMultilangVariations = crmObject => {
  return crmObject.associatedObjects && crmObject.associatedObjects.OBJECT_TO_TRANSLATIONS ? crmObject.associatedObjects.OBJECT_TO_TRANSLATIONS : [];
};
export const getHasMultilangVariations = crmObject => {
  const variations = getMultilangVariations(crmObject);
  return variations.length > 0;
};
export const getMultiLangGroupSize = crmObject => {
  return getMultilangVariations(crmObject).length + 1;
};
export const getContentGroups = crmObject => {
  return crmObject.associatedObjects && crmObject.associatedObjects.OBJECT_TO_CONTENT_GROUP ? crmObject.associatedObjects.OBJECT_TO_CONTENT_GROUP : [];
};
export const getContentGroupForContent = crmObject => {
  const contentGroupId = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID);
  const contentGroups = getContentGroups(crmObject);
  return contentGroups.find(group => getContentPropertyValue(group, CONTENT_PLATFORM_PROPERTY_NAME.ID) === contentGroupId);
};
export const getAllVariationLanguagesForContentObject = ({
  crmObject,
  existingLanguages = []
}) => {
  return getMultilangVariations(crmObject).reduce((acc, translatedCrmObject) => {
    const translatedCrmObjectLanguage = getContentPropertyValue(translatedCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
    if (translatedCrmObjectLanguage) {
      acc.push(translatedCrmObjectLanguage);
    }
    return acc;
  }, existingLanguages);
};
export const getAllContentGroupVariationLanguagesForContent = crmObject => {
  const contentGroup = getContentGroupForContent(crmObject);
  if (contentGroup) {
    return getAllVariationLanguagesForContentObject({
      crmObject: contentGroup
    });
  }
  return [];
};
export function getExistingGroupLanguagesForNewPrimary(selectedPrimary, contentGroups) {
  let selectedPrimaryLanguage = getContentPropertyValue(selectedPrimary, CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
  if (contentGroups.length > 0 && !selectedPrimaryLanguage) {
    const contentGroupLanguage = getContentPropertyValue(contentGroups[0], CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
    if (contentGroupLanguage) {
      selectedPrimaryLanguage = contentGroupLanguage;
    }
  }
  const existingGroupLanguages = selectedPrimaryLanguage ? [selectedPrimaryLanguage] : [];

  // collect all languages for currently selected multi-language group
  return getAllVariationLanguagesForContentObject({
    crmObject: selectedPrimary,
    existingLanguages: existingGroupLanguages
  });
}